import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link, Redirect } from 'react-router-dom';
import Header from '../../components/Header';
import Button from '../../components/Button';
import LinkList from '../../components/LinkList';
import helpFields from '../../forms/help';
import { extractPhasesOrFail } from '../../helpers/ValueBuilder';
import formHelpers from '../../helpers/FormHelpers';

class Help extends Component {
  constructor() {
    super();
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleSubmitClick = this.handleSubmitClick.bind(this);
    this.handleFieldBlur = this.handleFieldBlur.bind(this);
    this.handleEnter = this.handleEnter.bind(this);
    this.handleFieldFocus = this.handleFieldFocus.bind(this);
  }

  componentWillMount() {
    this.setState({
      fields: helpFields
    })
  }

  handleFieldBlur(name) {
    formHelpers.handleFieldBlur(name, 'fields', this);
  }

  handleFieldChange(value, name) {
    formHelpers.handleFieldChange(value, name, 'fields', this);
  }

  handleFieldFocus(name) {
    formHelpers.handleFieldFocus(name, 'fields', this);
  }

  handleEnter(e) {
    e.preventDefault();
    this.handleSubmitClick();
  }

  handleSubmitClick() {
    const { fields } = this.state;
    let data = extractPhasesOrFail({ fields });
    if (data) { 
        let myWindow = window.open('mailto:support@cinch.io?subject=' + data.subject + '&body='+ data.name+ ' sent the following message: ' + data.message);
            setTimeout(()=>{
                myWindow.close();
                myWindow.focus();                
            },30);
    } else {
      this.setState({
        fields: this.blurphase(fields)
      })
    }
  }

  generateLinks = () => [{
    to: '/terms-of-service',
    text: 'Terms of Service'
  }, {
    to: '/privacy-policy',
    text: 'Privacy Policy'
  }];

  render() {
    const { fields } = this.state;
    return (
      <div>
				<Header
          handleLogout={this.props.handleLogoutClick}
          title="HELP" />
        <LinkList linkItems={this.generateLinks()}/>
        <div className="saga-wrap">
          <div className="saga">
            <form className="signin__form" onSubmit={this.handleEnter}>
              <h2 className="">Contact Us</h2>
              { formHelpers.buildFields(fields, this) }
              <div className="clear"></div>
              <Button
                text="Send"
                allowHover={true}
                center={true}
  							makeFull={true}
                type="submit"
                onClick={() => {}}/>
              <div className="clear"></div>
              <p className="">Or call us at 801.783.1441</p>
            </form>
            <div className="clear"></div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(
  (state) => ({
  })
)(Help));



/** WEBPACK FOOTER **
 ** ./src/containers/Help/index.js
 **/